export const csRule = (choice: number, choicesLength: number): number => {
  const index = resolveIndex(choice)

  if (index >= choicesLength) {
    return choicesLength - 1
  }

  return index
}

const resolveIndex = (choice: number): number => {
  if (choice === 0) {
    return 2 // many
  }

  const teen = choice > 10 && choice < 20
  if (!teen) {
    switch (choice % 10) {
      case 1:
        return 0 // one
      case 2:
      case 3:
      case 4:
        return 1 // few
    }
  }

  return 2 // many
}
